import {
  CButton,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableRow,
} from "@coreui/react";
import { useState } from "react";
import DeleteIcon from "../../icons/DeleteIcon";
import PromptModal from "../../modals/PromptModal";

interface ReviewTableProps {
  reviews: any[];
  handleDeleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export default function BookingReviewTable({
  reviews,
  handleDeleteReview,
  isDeletingReview,
}: ReviewTableProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [reviewToDeleteId, setReviewToDeleteId] = useState<string | null>(null);
  const openModal = (id: string) => {
    setReviewToDeleteId(id);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setReviewToDeleteId(null);
  };

  const confirmDelete = async () => {
    if (!reviewToDeleteId) return;
    await handleDeleteReview(reviewToDeleteId);
    closeModal();
  };
  return (
    <>
      <CTable responsive>
        <thead>
          <tr>
            <th>Etablissement</th>
            <th>Date</th>
            <th>Commentaire</th>
            <th>Note</th>
            <th>Actions</th>
          </tr>
        </thead>
        <CTableBody>
          {reviews.map((review) => (
            <CTableRow key={review.id}>
              <CTableDataCell>{review.place_name}</CTableDataCell>
              <CTableDataCell>
                {new Date(review.review_createdAt).toLocaleDateString()}
              </CTableDataCell>
              <CTableDataCell>{review.review_comment || "-"}</CTableDataCell>
              <CTableDataCell>{review.review_rating}/5</CTableDataCell>
              <CTableDataCell>
                <CButton
                  color=""
                  size="sm"
                  onClick={() => {
                    openModal(review.review_id);
                  }}
                >
                  <DeleteIcon />
                </CButton>
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
      <PromptModal
        open={modalOpen}
        onClose={closeModal}
        onAccept={confirmDelete}
        loading={isDeletingReview}
      />
    </>
  );
}
